import { QueryFeature } from '../../../../../../../../../config/queryClient';

enum QueryKey {
  SourceAccounts = 'SourceAccounts',
}

export const queryKeys = {
  sourceAccounts: (
    clientId: number,
    fpId: string,
    year: number | null,
    accountOwner: string | null,
  ) => [QueryFeature.AnnuityPurchase, QueryKey.SourceAccounts, clientId, fpId, year, accountOwner],
};
